module.exports = __webpack_public_path__ + "static/img/right.4c1aa2da.png";